export const SUPPORTED_LOCALES = ['sq', 'en', 'de', 'mk', 'fr', 'es', 'it', 'sv'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const DEFAULT_LOCALE: SupportedLocale = 'sq';
export const FALLBACK_LOCALE: SupportedLocale = 'en';

export const LOCALE_STORAGE_KEY = 'mika.locale';
export const LEGACY_LOCALE_STORAGE_KEY = 'mikaSelectedLanguage';

export const PSEUDO_LOCALE = 'en-XA';

export interface LocaleMeta {
    native: string;
    english: string;
}

export const LOCALE_META: Record<SupportedLocale, LocaleMeta> = {
    sq: { native: 'Shqip',       english: 'Albanian' },
    en: { native: 'English',     english: 'English' },
    de: { native: 'Deutsch',     english: 'German' },
    mk: { native: 'Македонски',  english: 'Macedonian' },
    fr: { native: 'Français',    english: 'French' },
    es: { native: 'Español',     english: 'Spanish' },
    it: { native: 'Italiano',    english: 'Italian' },
    sv: { native: 'Svenska',     english: 'Swedish' },
};

export function isSupportedLocale(value: unknown): value is SupportedLocale {
    return typeof value === 'string'
        && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}
